<template>
    <Modal title="Demo Reivew" v-model="showModal" width="750">
      <Row>
        <div class="evaluate">
          <h3>Part one: Class performance  :</h3>
          <h4>
            Student's overal performance in English learning(must include the student's strengths and weaknesses in listening/speaking/reading/writing/grammar etc, no less than 30 words in total)
          </h4>
          <el-input
            type="textarea"
            :rows="3"
            placeholder="Enter something..."
            v-model="formData.remark">
          </el-input>
        </div>
      </Row>
      <Row>
        <div class="evaluate">
          <h3>Part two： Learning Suggestions :</h3>
          <p>
            The demo level is  <input type="text" v-model="formData.word1" > (a bit difficult/a perfect fit/a bit easy) for the
            student, so I suggest starting your English journey from <input type="text" v-model="formData.word2" >(a particular level that 
            we have) and taking classes twice or three times a week to ensure a great learning outcome.
            Overall, I am very pleased with our first class together. You did a wonderful job
            participating the class activities and  I look forward to seeing you again soon in the
            classroom.
          </p>
        </div>
      </Row>
      <div slot="footer">
        <Button type="text" size="large" @click="onClose">Cancel</Button>
        <Button v-if="!readonly" type="primary" size="large" :loading="loading" @click="onSubmit">Submit</Button>
      </div>
    </Modal>
</template>
<script>
    export default {
      name: 'StudentWriteReviewDemo',
      props: {
        formData: {
          type: Object,
          default: {
            return: {}
          }
        },
        value: {
          type: Boolean,
          default: {
            return: false
          }
        },
        openedId: {
          type: Number
        },
        reviewState: {
          type: Number
        },
        readonly: {
          type: Boolean,
          default: false
        },
        skipPart1: {
          type: Boolean,
          default: {
            return: false
          }
        }
      },
      data () {
        return {
          uid: '',
          openid: '',
          state: '',
          showModal: this.value,
          loading: false,
          lessonErrRule: {
            remark: [
              { type: 'string', required: true, message: ' ', trigger: 'blur' }
            ],
          }
        }
      },
      methods: {
        hasNumWords (str, num) {
          const words = str.split(' ') // 将字符串按空格切割成单词数组
          return words.length >= num // 判断单词数量是否大于等于80
        },
        onload () {
          let self = this
          self.$http.get('/bookTchFeedback/queryByLsnOpenId?lsnOpenId=' + self.openid).then(res => {
            let {uid, demoComment} = res.data
            self.uid = uid
            if (demoComment) {
              // 回显
              let obj = JSON.parse(demoComment)
              this.formData.remark = obj.part1
              let word = obj.part2.split(',')
              if (word.length > 1) {
                [this.formData.word1, this.formData.word2] = word
              }
            } else {
              // 重置
              this.formData.remark = ''
              this.formData.word1 = ''
              this.formData.word2 = ''
            }
          })
        },
        onClose () {
          this.$emit('on-close')
        },
        onSubmit () {
          let self = this
          let part1 = this.formData.remark
          // if (!self.hasNumWords(part1, 30) && !self.skipPart1) {
          //   self.$Message.error('Part 1 requires at least 30 words to be entered')
          //   return 
          // }
          if (this.formData.word1 === '' || this.formData.word2 === '') {
            self.$Message.error('Part 2 needs to be fully filled')
            return 
          }
          let part2 = [this.formData.word1, this.formData.word2].join(',')
          let data = {
            part1: part1,
            part2: part2
          }
          let parmas = {}
          parmas.demoComment = JSON.stringify(data)
          parmas.lsnOpenId = self.openid
          // parmas.reviewState = self.state
          parmas.uid = self.uid
          parmas.version = 1 
          this.$http.post('/bookTchFeedback/update', parmas).then(function (res) {
            self.$Message.success('success')
            self.showModal = false
          }).catch(function (e) {
            // this.loadingUpdate = false
          })
        },
      },
      watch: {
        reviewState (val) {
          this.state = val
        },
        openedId (val) {
          this.openid = val
        },
        value (val) {
          this.showModal = val
          if (val === true) {
              // this.scoreCompute()
            this.onload()
          } else {
            // this.feedback = {}
            // this.visible = val
          }
        },
        showModal (val) {
          if (val === false) {
            this.$emit('on-close')
          }
        },
        formData (val) {
          if (val) {
            this.lessonErrFormData = val
          }
        }
      }
    }
</script>



// WEBPACK FOOTER //
// StudentWriteReviewDemoModal.vue?1b50de82